export default __webpack_public_path__ + "static/media/cda1a182e992cbf0.d8248af71875ed9c641262cf8d9673eb.svg";